/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HealthMonitorModule
 */

import { Component, Input } from '@angular/core';
import { HealthMonitor } from 'object-types';
import { HealthMonitorItem } from 'ajs/modules/healthmonitor/factories';

import './health-monitor.port-ip-group.component.less';
import * as globalL10n from 'global-l10n';

const { ...globalL10nKeys } = globalL10n;

/**
 * @description Health Monitor component for Port and IP Address fields.
 * @author Shahab Hashmi
 */
@Component({
    selector: 'health-monitor-port-ip-group',
    templateUrl: './health-monitor.port-ip-group.component.html',
})
export class HealthMonitorPortIpGroupComponent {
    /**
     * Health Monitor ObjectTypeItem instance.
     */
    @Input()
    public editable: HealthMonitorItem;

    /**
     * Flag to show/hide Port input field.
     */
    @Input()
    public hidePortInput = false;

    public readonly globalL10nKeys = globalL10nKeys;

    /**
     * Object types used in template.
     */
    public readonly objectTypes = {
        HealthMonitor,
    };
}
